import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';

export const RadiusFilterOptions = ({
  items,
  selectedId,
  onSelect,
  excludeFromWriteActions,
  intl,
  isResetEditAfterChange,
}) => (
  <div className="unified-filters__content unified-filters__content__radius">
    {items.map(item => (
      <label className="radius-item" key={item.id} htmlFor={`radius-${item.id}`}>
        <input
          id={`radius-${item.id}`}
          type="radio"
          name="radius-value"
          onChange={() =>
            onSelect(item.id, {
              excludeFromWriteActions,
              resetIsEditing: isResetEditAfterChange,
            })
          }
          checked={selectedId === item.id}
        />
        <span>
          {item.name ? intl.formatMessage(item.name) : intl.formatMessage(item.defineMessage, { radius: item.radius })}
        </span>
      </label>
    ))}
  </div>
);

RadiusFilterOptions.propTypes = {
  selectedId: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      defineMessage: PropTypes.any.isRequired,
      id: PropTypes.number.isRequired,
      radius: PropTypes.string,
      value: PropTypes.number.isRequired,
    })
  ),
  onSelect: PropTypes.func.isRequired,
  excludeFromWriteActions: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  isResetEditAfterChange: PropTypes.bool.isRequired,
};
